import { Button, Text, useMantineTheme } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { FlexExtended } from '@dealstack/frontend/shared/components/Flex/FlexExtended';

interface Props {
	text: string;
	onClose: () => void;
}

export const AppliedFilter = ({ text, onClose }: Props) => {
	const theme = useMantineTheme();

	return (
		<FlexExtended
			border={`1px solid ${theme.colors.black[0]}`}
			borderRadius="0.25rem"
			p="0.25rem"
			m="0 0 0.5rem 0"
		>
			<Text size="xs">{text}</Text>
			<Button
				size="compact-xs"
				variant="ghost"
				onClick={() => onClose()}
				aria-label="Remove filter"
				styles={{
					root: {
						'&:hover': {
							backgroundColor: 'transparent',
						},
					},
				}}
			>
				<Icon variant="close-v3" size="lg" color="black"></Icon>
			</Button>
		</FlexExtended>
	);
};
